import React, { useEffect, useState } from 'react'

const SCRIPT_ID = "AKfycbzabu39DOoz7onuOYXtSRkmhtO4VSYz5rxw6mKv4oAnMebwfWlJJh1nEzPdqIttvUscJg";

export function Reader({ url }: { url: string }) {

  const [data, setData] = useState<any>(null);

  useEffect(() => {

    if (!url) return;

    fetch(

      `https://script.google.com/macros/s/${SCRIPT_ID}/exec?url=${encodeURIComponent(url)}`

    )

      .then((r) => r.json())

      .then(setData)

      .catch((err) => console.error("Reader error:", err));

  }, [url]);

  if (!data) {

    return <div className="p-4">Loading...</div>;

  }

  const article = data.data;

  return (

    <div dir='rtl' className="p-4 max-w-2xl">

      {article?.image && (

        <img src={article.image} className="rounded mb-4" />

      )}

      <h1 className="dv text-justify text-xl font-bold mb-2">

        {article?.title}

      </h1>

      <p className="text-lg whitespace-pre-wrap dhi ">

        {article?.content}

      </p>

    </div>

  );

}